import React from 'react'
import { Outlet } from 'react-router-dom'
import {
  PageHome,
  PageError404,
  PageAboutUs,
  PageContact,
  PageTermsAndConditions,
  PagePrivacyPolicy,
  PageCareers,
  SourceAssure,
  SeedAssure,
  CropAssure,
  CarbonFarming,
  Sustainability,
  SupplyChain,
  BlogsAndUpdates,
  CaseStudies,
  IPM,
  Technology,
  Loader,
  ReturnPolicy,
  DeleteAccount,
  SprayPPAccount,
  ESG
} from 'screens/index'

import { Cumin, Fennel, Fenugreek, Mustard, Coriander } from 'screens/products'
import {
  Board,
  IPO,
  KMP,
  Meetings,
  Policies,
  ShareHoldingPatterns,
  Finance,
  Group,
  Grievance,
  Subsidiary,
  Commitee,
  Contract,
  Document,
  Creditors,
  SddCompliance,
  CertUnderSebi,
  CorporateGovernance,
  ReconciliationShareCapital,
  InvestorMeet,
  BoardMeeting,
  StatementDeviation,
  PressRelease,
  InvestorDeck,
  SEFOther,
  InvestorsForms
} from 'screens/investors'

import { Header, Footer } from 'layouts/index'
import Profile from 'screens/investors/Profile'
import DirectorProfile from 'screens/investors/NonExeProfile'
import CSR from 'screens/csr'
import path from 'path'

function ViewWithHeaderAndFooter() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  )
}

export default function routes() {
  return [
    {
      path: '/',
      element: <ViewWithHeaderAndFooter />,
      children: [
        {
          path: '/',
          element: <PageHome />,
        },
        {
          path: '/contact-us',
          element: <PageContact />,
        },
        {
          path: '/careers',
          element: <PageCareers />,
        },
        {
          path: '/blogs-and-updates',
          element: <BlogsAndUpdates />,
        },
        {
          path: '/technology',
          element: <Technology />,
        },
        {
          path: '/supply-chain',
          element: <SupplyChain />,
        },
        {
          path: '/about-us',
          element: <PageAboutUs />,
        },
        {
          path: '/terms-of-use',
          element: <PageTermsAndConditions />,
        },
        {
          path: '/privacy-policy',
          element: <PagePrivacyPolicy />,
        },
        {
          path: '/refund-policy',
          element: <ReturnPolicy />,
        },
        {
          path: '/crop-assure',
          element: <CropAssure />,
        },
        {
          path: '/source-assure',
          element: <SourceAssure />,
        },
        {
          path: '/seed-assure',
          element: <SeedAssure />,
        },
        {
          path: '/carbon-farming',
          element: <CarbonFarming />,
        },
        {
          path: '/sustainability',
          element: <Sustainability />,
        },
        {
          path: '/case-studies',
          element: <CaseStudies />,
        },
        {
          path: '/ipm',
          element: <IPM />,
        },
        {
          path: '/csr',
          element: <CSR />
        },
        {
          path:'/ipo',
          element:<IPO />
        },
        {
          path: '/subsidiary',
          element: <Subsidiary />
        }, 
        {
          path: '/esg-profile',
          element: <ESG />
        }
      ],
    },
    {
      path: '/',
      element: <ViewWithHeaderAndFooter />,
      children: [
        {
          path: '/details-of-boards',
          element: <Board />,
        },
        {
          path: '/meetings',
          element: <Meetings />,
        },
        {
          path: '/shareholding-patterns',
          element: <ShareHoldingPatterns />,
        },
        {
          path: '/sdd-compliance',
          element: <SddCompliance />,
        },
        {
          path: '/corporate-governance',
          element: <CorporateGovernance />
        },
        {
          path: '/reconciliations',
          element: <ReconciliationShareCapital />
        },
        {
          path: '/certificate-under-sebi',
          element: <CertUnderSebi />
        },
        { 
          path: '/policies',
          element: <Policies />
        },
        {
          path: '/finance',
          element: <Finance />
        },
        {
          path: 'ipo',
          element: <IPO />
        },
        {
          path: 'kmp',
          element: <KMP />
        },
        {
          path: '/group-companies',
          element: <Group />
        },
        {
          path: '/material-contracts',
          element: <Contract />
        },
        {
          path: '/material-documents',
          element: <Document />
        },
        {
          path: '/material-creditors',
          element: <Creditors />
        },
        {
          path: '/investor-grievance',
          element: <Grievance />
        },
        {
          path: '/investor-forms',
          element: <InvestorsForms />
        },
        {
          path: '/profile/:id',
          element: <Profile />
        },
        {
          path: '/commitee',
          element: <Commitee/>
        },
        {
          path: '/directors/:id',
          element: <DirectorProfile />
        },
        {
          path: '/investors-meet',
          element: <InvestorMeet />
        },
        {
          path: '/board-meeting',
          element: <BoardMeeting />
        },
        {
          path: '/statement-deviation',
          element: <StatementDeviation />
        },
        { 
          path: '/press-release',
          element: <PressRelease />
        },
        {
          path: '/investor-deck',
          element: <InvestorDeck />
        },
        {
          path: '/others',
          element: <SEFOther />
        }
      ],
    },

    {
      path: '/delete-account',
      element: <DeleteAccount />
    },
    // {
    //   path: '/spray-assure-privacy',
    //   element: <SprayPPAccount />
    // },

    {
      path: '/products',
      element: <ViewWithHeaderAndFooter />,
      children: [
        {
          path: 'cumin',
          element: <Cumin />,
        },
        {
          path: 'fenugreek',
          element: <Fenugreek />,
        },
        {
          path: 'fennel',
          element: <Fennel />,
        },
        {
          path: 'mustard',
          element: <Mustard />,
        },
        {
          path: 'coriander',
          element: <Coriander />,
        }
      ],
    },
    {
      path: '',
      element: <ViewWithHeaderAndFooter />,
      children: [
        { path: '*', element: <PageError404 /> },
        { path: '/loading', element: <Loader /> }
      ],
    }
  ]
}
